import React from 'react';
import { motion } from 'framer-motion';

const RenderArticleSkeleton = () => {
  const skeletonVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5 }
    }
  };

  return (
    <motion.div
      variants={skeletonVariants}
      initial="hidden"
      animate="visible"
      className="space-y-6"
    >
      {[...Array(2)].map((_, index) => (
        <motion.div
          key={index}
          variants={itemVariants}
          className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-4 sm:p-6 border border-gray-200"
        >
          <div className="flex flex-col lg:flex-row gap-6">
            {/* Text content skeleton */}
            <div className="flex-1 space-y-4">
              {/* Title skeleton - Light Gray */}
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 bg-gradient-to-r from-gray-200 to-gray-300 rounded-lg animate-pulse" />
                <div className="h-8 bg-gray-200 rounded-lg animate-pulse w-48" />
              </div>

              {/* Subtitle skeleton */}
              <div className="h-6 bg-gray-200 rounded-lg animate-pulse w-64" />

              {/* Paragraph skeletons - Light Gray */}
              <div className="space-y-2">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-full" />
                <div className="h-4 bg-gray-200 rounded animate-pulse w-5/6" />
                <div className="h-4 bg-gray-200 rounded animate-pulse w-4/6" />
                <div className="h-4 bg-gray-200 rounded animate-pulse w-full" />
                <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4" />
              </div>
            </div>

            {/* Image skeleton - Light Gray */}
            <div className="lg:w-80 xl:w-96">
              <div className="relative">
                <div className="absolute -inset-2 bg-gradient-to-r from-gray-200 to-gray-300 rounded-2xl opacity-40 blur-xl" />
                <div className="relative w-full h-48 sm:h-56 lg:h-64 bg-gray-200 rounded-xl animate-pulse" />
              </div>
            </div>
          </div>
        </motion.div>
      ))}
    </motion.div>
  );
};

export default RenderArticleSkeleton;